export default "/directory/static/digital_files_included.940c858d.svg";